// Shared booking link, used everywhere a "Kostenloses Erstgespräch anfragen"
// CTA should send visitors straight to the cal.com scheduler instead of the
// contact form. Keep this in sync with the CAL_LINK constant used in the
// "System-Prompt bauen" node of the Kurpfalz-Website-LeadBot n8n workflow.
export const CAL_LINK = "https://cal.com/kurpfalz-automation/30min";
